exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio-container{height:240px;width:240px;margin:40px;display:flex;align-items:center;background:linear-gradient(180deg,#fff,#a9a9a9)}.audio-controls{margin-left:-13px;margin-right:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c74350fa","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/previews/SingleFreeVoice.vue
// module id = 398
// module chunks = 1